import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/**
 * The `lookupStandards` tool call: standards, topics, and subtopics from the catalog.
 *
 * The row names each standard and counts its topics. It does not render the keyword chips.
 * The model still receives those keywords in the tool output.
 */
function LookupStandardsToolCall({ part }: IAiChatToolCallOf<'lookupStandards'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('lookupStandards');
  const status = useAiChatToolStatus(part.state);
  const asked = [part.input?.standardName, part.input?.query].filter(Boolean).join(' · ');

  let summary = status;

  if (part.state === 'output-available') {
    if (!part.output.ok) {
      summary = part.output.reason;
    } else if (part.output.standards.length === 0) {
      summary = t('aiChat.tools.standardsLookupEmpty');
    } else {
      summary = part.output.standards
        .map((standard) => t('aiChat.tools.standardsListed', {
          name: standard.name,
          count: standard.topics.length,
        }))
        .join(', ');
    }
  }

  return (
    <AiChatToolCard name={label} status={summary} errorText={part.errorText}>
      {asked}
    </AiChatToolCard>
  );
}

export default LookupStandardsToolCall;
